<script setup lang="ts">
import HomeSummary from '@/components/home/HomeSummary.vue';


</script>

<template>
  <main>
    <HomeSummary/>
  </main>
</template>
